import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
import zip from '@drivesally/sally-fw/lib/type/types/zip.type';

export default attribute({
  type: TEXT,
  attribute: 'zipcode',
  display: zip,
  input: zip,
  api: zip,
  label: {
    default: 'Zip',
    short: 'Zip',
  },
});
